/**
 * @file Map Redux dispatch to compose props
 */

import { MapDispatchToProps } from 'react-redux';

import { clearDraftRequest } from '../../store/actions/draftsMain';
import {
  saveDraftTemplateRequest,
  setDraftTemplateRequest,
} from '../../store/actions/draftsTemplate';

import { DispatchProps, OwnProps } from './props';

/**
 * Map Redux dispatch to compose props
 *
 * @param dispatch          Redux dispatch
 * @param ownProps          Props passed to the container
 * @param ownProps.nodeType The key for the Redux store draft
 * @returns                 Props to add to compose
 */
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { nodeType },
) => ({
  /**
   * Dispatches clearing draft request
   *
   * @param topicId Id of the topic to clear the draft for
   */
  requestDraftClear: topicId => {
    dispatch(clearDraftRequest(nodeType, topicId));
  },
  /**
   * Dispatches saving draft template request
   *
   * @returns void
   */
  requestTemplateSave: () => dispatch(saveDraftTemplateRequest(nodeType)),
  /**
   * Dispatches setting draft template request
   *
   * @param templateId Id of the template to set
   */
  requestTemplateSet: templateId => {
    dispatch(setDraftTemplateRequest(nodeType, templateId));
  },
});

export default mapDispatchToProps;
